import { lazy, Suspense } from 'react';
import { useMe } from '../lib/me';
import { Loading } from '../components/ui';
import { NotFound } from './NotFound';

/**
 * Every dashboard (divisions, Rules & Documentation, Management Tools) is a board: tools and
 * pages in categories, organised by management, with a New page button.
 */
const SectionBoard = lazy(() => import('../../tools/rules-index/board'));

export function SectionPage({ id }: { id: string }) {
  const { me } = useMe();
  const s = me?.nav.find((x) => x.id === id);
  if (!s || s.layout !== 'dashboard') return <NotFound />;
  return <Suspense fallback={<Loading />}><SectionBoard section={s} /></Suspense>;
}
